$('.ingredients-tab ul li').click(function() {
  $('html, body').animate({
    scrollTop: $("#shopify-section-product-ingredients").offset().top - 100
  }, 2000);
})

$('.jdgm-all-reviews-widget').click(function() {
    $('html, body').animate({
    scrollTop: $("#shopify-section-product-reviews").offset().top - 100
  }, 2000);
})

$(".Reasons_Testimonials_Inner").slick({
  slidesToShow: 1,
  dots: false,
  arrows: true,
  infinite: true,
  adaptiveHeight: true
})

$(".Days_Carousel").slick({
  slidesToShow: 1,
  dots: true,
  arrows: false,
  infinite: true,
  adaptiveHeight: true,
  responsive: [
  {
    breakpoint: 768,
    settings: {
      arrows: false
    }
  }
]
})

$(".Steps_Carousel_Inner").slick({
  slidesToShow: 1,
  dots: true,
  arrows: true,
  infinite: true,
  adaptiveHeight: true,
  responsive: [
  {
    breakpoint: 768,
    settings: {
      arrows: false
    }
  }
]
})


$('.up-sell-slider').slick({      
  slidesToShow: 6,
  slidesToScroll: 1,
  infinite: true,
  speed: 1500,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  variableWidth: true,
  prevArrow: false,
  nextArrow: false
});


// $('.ingredients-v4-slider').slick({
//   dots: true,
//   arrows: true,
//   infinite: true,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   responsive: [
//     {
//       breakpoint: 991,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]

// });